var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group", class: _vm.computedClasses }, [
    _c(
      "div",
      {
        staticClass: "form-check city-form-check mb-0 pl-0 user-select-none",
        class: [{ "form-check-inline": _vm.isInline }, _vm.inputClasses],
      },
      [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            "false-value": _vm.falseValue,
            "true-value": _vm.trueValue,
            readonly: _vm.readonly,
            disabled: _vm.disabled,
            required: _vm.required,
            type: "checkbox",
            name: _vm.name,
            id: _vm.id,
            title: _vm.title,
          },
          domProps: { checked: _vm.isChecked },
          on: { change: _vm.handleCheckboxChange },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label h-auto",
            class: [_vm.labelClass],
            attrs: { for: _vm.id },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-start align-items-center flex-nowrap flex-row",
              },
              [
                _vm._t("default", function () {
                  return [_vm._v("  ")]
                }),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _vm.error
          ? _c("small", { staticClass: "invalid-feedback" }, [
              _vm._v(_vm._s(_vm.error)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("HelpSpan", {
          attrs: { helpText: _vm.helpText, truncateText: _vm.helpTruncate },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }